var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRundown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97007 25.2482H0.625V0.625H21.1444V2.97007",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1133 27.5935H2.97006V2.97021H23.4894V17.0406",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9384 17.0405H11.1133V30.9585H29.9384V17.0405Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1133 25.5943H16.0497L18.6703 21.1445L22.7156 28.4377L24.6561 25.0843H29.9384",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6653 12.3506H9.75905C9.75905 10.4452 11.3068 8.89746 13.2122 8.89746C15.1175 8.89746 16.6653 10.4452 16.6653 12.3506Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7306 7.05652C14.7306 7.89489 14.0505 8.8974 13.218 8.8974C12.9894 8.8974 12.7783 8.82119 12.5849 8.69807C12.4207 8.59254 12.2742 8.4577 12.1569 8.29941L12.1452 8.28769C11.8696 7.93006 11.6996 7.47277 11.6996 7.05066C11.6996 6.62855 11.8579 6.2592 12.1452 5.97779C12.4325 5.69638 12.8135 5.53223 13.218 5.53223C14.0564 5.53223 14.7306 6.2123 14.7306 7.05066V7.05652Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9266 9.04961C16.3722 8.71544 16.9232 8.52197 17.5212 8.52197C18.9928 8.52197 20.1829 9.7121 20.1829 11.1836H17.7909",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6938 7.09734C18.6938 7.74223 18.172 8.5161 17.5271 8.5161C17.3512 8.5161 17.1871 8.45748 17.0405 8.36368C16.9115 8.2816 16.8001 8.17607 16.7122 8.05882H16.7063C16.4953 7.77741 16.3663 7.42565 16.3663 7.09734C16.3663 6.76903 16.4894 6.48762 16.7063 6.2707C16.9233 6.05378 17.2223 5.93066 17.533 5.93066C18.1779 5.93066 18.6996 6.4583 18.6996 7.09734H18.6938Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60408 11.1773H6.2766C6.2766 9.70575 7.46672 8.51562 8.93825 8.51562C9.49521 8.51562 10.0111 8.68564 10.4391 8.97878",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.105 7.09734C10.105 7.74223 9.58319 8.5161 8.93829 8.5161C8.76241 8.5161 8.59826 8.45748 8.45169 8.36368C8.32271 8.2816 8.21132 8.17607 8.12338 8.05882H8.11752C7.90646 7.77741 7.77748 7.42565 7.77748 7.09734C7.77748 6.76903 7.9006 6.48762 8.11752 6.2707C8.33444 6.05378 8.63343 5.93066 8.94415 5.93066C9.58905 5.93066 10.1108 6.4583 10.1108 7.09734H10.105Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10072 14.7656H20.6636",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20627 17.9902H10.5916",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20627 21.2148H10.5916",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20627 24.4395H10.5916",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRundown);
export default __webpack_public_path__ + "static/media/newRundown.2275a4f65c4e3d5dc926c25e89ec06bf.svg";
export { ForwardRef as ReactComponent };